import { cx } from 'class-variance-authority';

import { PhotoGridItem } from './PhotoGridItem';
import type { PhotoGridColumnProps } from './types';

export function PhotoGridColumn({
  className,
  colSpan,
  items,
}: Readonly<PhotoGridColumnProps>) {
  return (
    <div
      className={cx('flex flex-col gap-y-3 md:gap-y-5', className)}
      data-cy="pop_lifestyle_photo_grid_column"
      style={{ gridColumn: `span ${colSpan} / span ${colSpan}` }}
    >
      {items.map((item) => (
        <PhotoGridItem key={item.id} {...item} />
      ))}
    </div>
  );
}
